import { render, staticRenderFns } from "./tao1.vue?vue&type=template&id=e0a00c3c&scoped=true&"
import script from "./tao1.vue?vue&type=script&lang=js&"
export * from "./tao1.vue?vue&type=script&lang=js&"
import style0 from "./tao1.vue?vue&type=style&index=0&id=e0a00c3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a00c3c",
  null
  
)

export default component.exports